export default __webpack_public_path__ + "static/media/spt20.94dcf9af.jpeg";